


































import { SdsSnackbar } from '@superbet-group/web.lib.ui-components';
import {
    respondToBelow,
    ScreenWidth,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

import { useNotificationsStore } from './store';
import {
    SNACKBAR_NOTIFICATION_DEFAULT_DESKTOP_BOTTOM_OFFSET_PX,
    SNACKBAR_NOTIFICATION_DEFAULT_MOBILE_BOTTOM_OFFSET_PX,
    SNACKBAR_NOTIFICATION_STICKY_DESKTOP_TOP_OFFSET_PX,
    SNACKBAR_NOTIFICATION_STICKY_MOBILE_TOP_OFFSET_PX,
} from './offsets';

export default defineComponent({
    name: 'SnackbarNotifications',
    setup() {
        const {
            visibleNotification,
            hideNotification,
        } = useNotificationsStore();

        function onButtonClick() {
            visibleNotification.value?.actionButton?.onClick();
            hideNotification();
        }

        function onCloseClick() {
            if (visibleNotification.value?.hasClose) {
                hideNotification();
            }
        }

        const isMobile = computed(() => respondToBelow(ScreenWidth.dXs));

        return {
            bottomOffset: computed(() => {
                const defaultOffset = isMobile.value ? `${SNACKBAR_NOTIFICATION_DEFAULT_MOBILE_BOTTOM_OFFSET_PX}px` : `${SNACKBAR_NOTIFICATION_DEFAULT_DESKTOP_BOTTOM_OFFSET_PX}px`;
                const stickToTopOffset = 'unset';

                return visibleNotification.value?.bottomOffset ?? (visibleNotification.value?.stickToTop ? stickToTopOffset : defaultOffset);
            }),
            topOffset: computed(() => {
                const defaultOffset = 'unset';
                const stickToTopOffset = isMobile.value ? `${SNACKBAR_NOTIFICATION_STICKY_MOBILE_TOP_OFFSET_PX}px` : `${SNACKBAR_NOTIFICATION_STICKY_DESKTOP_TOP_OFFSET_PX}px`;

                return visibleNotification.value?.topOffset ?? (visibleNotification.value?.stickToTop ? stickToTopOffset : defaultOffset);
            }),
            visibleNotification,
            onButtonClick,
            onCloseClick,
        };
    },
    components: {
        SdsSnackbar,
    },
});
